import React from 'react';
import PropTypes from 'prop-types';

import { InputLabel as MUIInputLabel } from '@mui/material';

export const InputLabel = props => <MUIInputLabel {...props} />;

InputLabel.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  focused: PropTypes.bool,
  id: PropTypes.string,
  required: PropTypes.bool,
  shrink: PropTypes.bool,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export default InputLabel;
